import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import Home from './pages/Home';
import Browse from './pages/Browse';
import Game from './pages/Game';

function App() {
  const [isLoading, setIsLoading] = useState(true);

useEffect(() => {
    const fetchGames = async () => {
      try {
        const response = await axios.get('./Games.json');
        localStorage.setItem('gameData', JSON.stringify(response.data));
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching game data:', error);
        setIsLoading(false);
      }
    };

    if (localStorage.getItem('gameData')) {
      setIsLoading(false);
    } else {
      fetchGames();
    }
  }, []);

 return (
    <>
      <Navbar />
      <Routes>
        <Route
          path='/'
          element={
            <Home
              gameData={JSON.parse(localStorage.getItem('gameData'))}
              isLoading={isLoading}
            />
          }
        />
        <Route
          path='/browse'
          element={
            <Browse
              gameData={JSON.parse(localStorage.getItem('gameData'))}
              isLoading={isLoading}
            />
          }
        />
        <Route path='/game/:gameId' element={<Game />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
